import React, { useContext } from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Col, Popover, Row, Tag } from 'antd'
import { FormOutlined, UserOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { SLOT_COLORS } from '../../Common/Color'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import Info from '../../Common/Info'
import { post } from '../../Common/api'
import { notificationError, notificationSuccess } from '../../Common/Common'
import GlobalContext from '../GlobalContext'

export default function SlotList ({ slots, boxes, setLoading, updateSlots }) {
  const screens = useBreakpoint()
  const { data } = useContext(GlobalContext)

  const assign = (id) => {
    setLoading(true)
    post(`admin/slots/${id}/assign`, {}, (json) => {
      updateSlots(json)
      setLoading(false)
      notificationSuccess('update')
    }, () => {
      setLoading(false)
      notificationError('update')
    })
  }

  const columns = (screens, boxes) => [
    {
      title: t('Admin.SlotList.table.name'),
      dataIndex: 'name',
      key: 'name',
      width: 200,
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: <Info text={t('Admin.SlotList.table.bookedSlots')} infoText={t('Admin.SlotList.table.infoBookedSlots')} />,
      dataIndex: 'booked_slots',
      key: 'booked_slots',
      width: 170,
      render: (_, o) => bookedSlotsRender(o.booked_slots)
    },
    {
      title: t('Admin.SlotList.table.box'),
      dataIndex: 'box.name',
      key: 'box.name',
      render: (_, o) => `${o.box.name} - ${o.box.interphone}`,
      width: 200,
      sorter: (a, b) => a.box.name.localeCompare(b.box.name)
    },
    {
      title: t('Admin.SlotList.table.assigned'),
      dataIndex: 'assigned_short_name',
      key: 'assigned_short_name',
      width: 100,
      sorter: (a, b) => a.assigned_short_name.localeCompare(b.assigned_short_name),
      render: (_, o) => o.assigned_short_name
    },
    {
      width: 80,
      title: t('Admin.SlotList.table.slotType'),
      dataIndex: 'type',
      key: 'type',
      render: (_, o) => <Tag color={SLOT_COLORS[o.type]}>{t(`Admin.Slot.type.${o.type}`)}</Tag>,
      sorter: (a, b) => a?.type.localeCompare(b?.type),
      hidden: !screens.md
    },
    {
      width: 100,
      title: t('Admin.SlotList.table.range'),
      dataIndex: 'range',
      key: 'range',
      render: (_, o) => `${dayjs(o?.begin_date).format('H[h]mm')}-${dayjs(o?.end_date).format('H[h]mm')}`,
      sorter: (a, b) => dayjs(a.begin_date) - dayjs(b.begin_date)
    },
    {
      width: 100,
      title: t('Admin.SlotList.table.phone'),
      dataIndex: 'phone',
      key: 'phone',
      render: (phone) => `+${phone}`,
      sorter: (a, b) => a.phone - b.phone
    },
    {
      width: 160,
      title: t('Admin.SlotList.table.state'),
      dataIndex: 'state',
      key: 'state',
      render: (_, o) => <>
        <Row><Tag color={t(`Admin.Slot.stateColor.${o.state}`)}>{t(`Admin.Slot.state.${o.state}`)}</Tag></Row>
        {o.id === boxes.find((e) => e.id === o.box.id)?.current_slot?.id &&
          <Row><Tag color={t(`Admin.Box.stateColor.${boxes.find((e) => e.id === o.box.id).state}`)}>
            {t(`Admin.Box.state.${boxes.find((e) => e.id === o.box.id).state}`)}
          </Tag></Row>
        }
      </>,
      sorter: (a, b) => a?.state.localeCompare(b?.state)
    },
    {
      width: 70,
      title: t('Admin.SlotList.table.digicode'),
      dataIndex: 'digicode',
      key: 'digicode',
      sorter: (a, b) => a?.digicode.localeCompare(b?.digicode),
      hidden: !screens.md
    },
    {
      width: 80,
      key: 'action',
      render: (_, o) => <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Link to={`/admin/slots/${o.id}?from=list`}><Button shape="circle" icon={<FormOutlined />} /></Link>
        { o.assigned_id !== data.user.id &&
          <Button shape="circle" icon={<UserOutlined />} onClick={() => assign(o.id)} />
        }
      </div>
    }
  ].filter((col) => !col.hidden)

  const bookedSlotsRender = (bookedSlots) => {
    if (bookedSlots.slots) {
      return <Popover content={popOverContent(bookedSlots.slots)} title={t('Admin.SlotList.table.previousSlots')}>
        <span style={{ width: '100%', display: 'block' }}>
          {bookedSlots.count}
        </span>
      </Popover>
    } else {
      return bookedSlots.count
    }
  }

  const popOverContent = (slots) => {
    return slots.map(slot => (
      <Row key={slot.id} style={{ width: '30em' }}>
        <Col span={8}>{slot.box}</Col>
        <Col span={8}>{dayjs(slot.date).format('DD/MM/YYYY')}</Col>
        <Col span={8}><Tag color={t(`Admin.Slot.stateColor.${slot.state}`)}>{t(`Admin.Slot.state.${slot.state}`)}</Tag></Col>
      </Row>
    ))
  }

  return (
    <CustTable
      height={'calc(100vh - 230px)'}
      initColumns={columns(screens, boxes)}
      dataSource={slots}
    />
  )
}
